<template>
  <div>
    <iframe :src="setCookieUrl" v-show="false"></iframe>
    <!-- Player -->
    <video crossorigin="anonymous" id="video" height="100%" width="100%" controls>
      <track
        class="mv-tracks"
        v-for="(subtitle, index) in subtitles"
        :label="subtitle.lang_subtitle"
        kind="subtitles"
        :srclang="subtitle.lang_subtitle"
        :src="subtitle.src_subtitle"
        :key="index + 1"
      />
    </video>
  </div>
</template>

<script>
import VTTConverter from "srt-webvtt";
import { getSetCookieUrl } from "@/api/_manager";
import { hlsPlayer } from "@/mixins/tempHlsPlayer";

export default {
  name: "ScreenerPlayer",
  props: {
    movie: {
      type: String,
      default: null,
      recoverSwapAudioCodecDate: null,
      recoverDecodingErrorDate: null
    },
    subtitles: {
      default: Array
    }
  },
  data: () => ({
    setCookieUrl: getSetCookieUrl()
  }),
  mounted() {
    this.addTracks();
    if(this.movie){
      this.mountPlayer(this.movie);
    }
  },
  beforeDestroy() {
    this.destroyHLS();
  },
  mixins:[hlsPlayer],
  methods: {
    async addTracks() {
      for (var i = 0; i < this.subtitles.length; i++) {
        let blob = await this.getBlobFromUrl(this.subtitles[i].src_subtitle);
        var _i = i;
        const vttConverter = new VTTConverter(blob); // the constructor accepts a parameer of SRT subtitle blob/file object
        vttConverter
          .getURL()
          .then(function(url) {
            // Its a valid url that can be used further
            var track = document.getElementsByClassName("mv-tracks")[_i]; // Track element (which is child of a video element)
            var video = document.getElementById("video"); // Main video element
            track.src = url; // Set the converted URL to track's source
          })
          .catch(function(err) {
            console.error(err);
          });
      }
    },

    async getBlobFromUrl(url) {
      let blob = await fetch(url).then(r => r.blob());
      return blob;
    },

    getLenghtOfVideo(){
      let video = document.getElementById("video");
      if(!video) return 0;

      return parseInt(video.duration)
    }
  }
};
</script>

<style></style>
